export default {
      id: "user-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#user-icon",
      toString: function () {
        return this.url;
      }
    }